let base = {
	shareLogo: process.env.VUE_APP_SHARE_URL.replace("/#/","") + '/img/logo.png',
}

const shareWeiXin = (res, title, description, locationURL, imgUrl, callback) => {
	if (!imgUrl || imgUrl.length == 0 || imgUrl == undefined || imgUrl == null) {
		imgUrl = base.shareLogo
	}
	if(!description){
		description = "";
	}
	wx.ready(function () {
		/** 微信二次分享 **/
		if (!imgUrl || imgUrl.length == 0 || imgUrl == undefined || imgUrl == null) {
			imgUrl = base.shareLogo
		}
		let shareUrl = locationURL.indexOf('?')>-1 ? locationURL + "&tencentShare=1" : locationURL + "?tencentShare=1";
		try {
			var wxParams = {
				title: title,
				desc: description,
				link: shareUrl,
				imgUrl: imgUrl
			};
			wx.onMenuShareTimeline(wxParams);
			wx.onMenuShareAppMessage(wxParams);
			wx.onMenuShareQQ(wxParams);
			wx.onMenuShareQZone(wxParams);
			wx.onMenuShareWeibo(wxParams);
			if (typeof callback == "function")
				callback();
		} catch (err) {
			console.log(err);
		}
	});
	wx.config({
		debug: false,
		appId: res.data.appid, // 必填，公众号的唯一标识
		timestamp: res.data.timestamp, // 必填，生成签名的时间戳
		nonceStr: res.data.noncestr, // 必填，生成签名的随机串
		signature: res.data.sha1, // 必填，签名，见附录1
		jsApiList: [
			'onMenuShareTimeline',
			'onMenuShareAppMessage',
			'onMenuShareQQ',
			'onMenuShareWeibo',
			'onMenuShareQZone',
			'startRecord',
			'stopRecord',
			'onVoiceRecordEnd',
			'playVoice',
			'pauseVoice',
			'stopVoice',
			'onVoicePlayEnd'
		] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
	});
	/** QQ二次分享 **/
	initQQ(title, description, locationURL, imgUrl, {
		appId: res.data.appid, // 必填，公众号的唯一标识
		timestamp: res.data.timestamp, // 必填，生成签名的时间戳
		nonceStr: res.data.noncestr, // 必填，生成签名的随机串
		signature: res.data.sha1 // 必填，签名，见附录1
	});
};

/** QQ二次分享 **/
function initQQ(title, description, locationURL, imgUrl, wxConfig) {
	locationURL = locationURL.replace("&tencentShare=1", "");
	locationURL = locationURL.replace("?tencentShare=1", "");
	let shareUrl = locationURL.indexOf('?')>-1 ? locationURL + "&tencentShare=1" : locationURL + "?tencentShare=1";
	setShareInfo({
		title: title, // 分享标题
		summary: description, // 分享内容
		pic: imgUrl, // 分享图片
		url: shareUrl, // 分享链接
		WXconfig: {
			swapTitleInWX: false, //swapTitleWX必须false，否则，微信朋友圈分享标题会被summary覆盖
			appId: wxConfig.appId,
			timestamp: wxConfig.timestamp,
			nonceStr: wxConfig.nonceStr,
			signature: wxConfig.signature
		}
	});
}

export default {
	shareWeiXin
}